import { userConstants } from "../_constants";

let user = JSON.parse(localStorage.getItem("user"));
const initialState = user ? { loggedIn: true, user } : {};

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        loggingIn: true,
        user: action.user
      };
    case userConstants.LOGIN_SUCCESS:
      // action.user.user_id = 9;
      // action.user.user_title = "Test";

      // action.user.dependant_user_id = 9;
      // action.user.dependant_title = "Test 2";

      return {
        loggedIn: true,
        user: action.user
      };
    case userConstants.LOGIN_FAILURE:
      return {};
    case userConstants.LOGOUT:
      return {};
    case userConstants.SET_SETUP:
      let oldUser = JSON.parse(localStorage.getItem("user"));
      const user = {
        ...oldUser,
        already_set_up: true
      };
      localStorage.setItem("user", JSON.stringify(user));
      return {
        loggedIn: true,
        user: {
          ...user
        }
      };
    default:
      return state;
  }
}
